import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {HttpCommonService} from '../../../../shared/services/http-common.service';
import {Observable} from 'rxjs';
import {GenericHttpResponse} from '../../../../shared/services/interfaces/generic-http-response.interface';

export interface CiudadDetalle {
  id: number;
  ubi_departamento_id: number;
  nombre: string;
  codigo: string;
  created_at: string;
  updated_at: string;
  departamento?: DepartamentoDetalle;
}

export interface DepartamentoDetalle {
  id: number;
  ubi_pais_id: number;
  nombre: string;
  codigo: string;
  created_at: string;
  updated_at: string;
  pais?: PaisDetalle;
}

export interface PaisDetalle {
  id: number;
  nombre: string;
  nacionalidad: string;
  codigo: string;
  abrev: string;
  created_at: string;
  updated_at: string;
}

@Injectable({
  providedIn: 'root'
})
export class UbicacionService {
  private http = inject(HttpClient);
  private httpCommonService = inject(HttpCommonService);

  getCiudad(id: number): Observable<GenericHttpResponse<CiudadDetalle>> {
    const url = this.httpCommonService.makeUrl(`/ubic/ciudades/${id}`);
    return this.http.get<GenericHttpResponse<CiudadDetalle>>(url);
  }

  getDepartamento(id: number): Observable<GenericHttpResponse<DepartamentoDetalle>> {
    const url = this.httpCommonService.makeUrl(`/ubic/departamentos/${id}`);
    return this.http.get<GenericHttpResponse<DepartamentoDetalle>>(url);
  }
}
